import actionCreatorFactory from 'typescript-fsa';
import * as types from '../types/online_test_log';
var actionCreator = actionCreatorFactory();
export var requestOnlineTestLog = actionCreator(types.GET_ONLINE_TEST_LOG);
export var successOnlineTestLog = actionCreator(types.SUCCESS_GET_ONLINE_TEST_LOG);
export var failureOnlineTestLog = actionCreator(types.FAILURE_GET_ONLINE_TEST_LOG);